import React from "react";
import "./header.scss";

const Header = ({ children, onClickButton, buttonTxt }) => (
    <header className={onClickButton ? "appHeader appHeader_withButton" : "appHeader"}>
        <div className="headerContent">
            {children}
            {onClickButton && buttonTxt && (
                <button className="button ghost" onClick={onClickButton}>
                    {buttonTxt}
                </button>
            )}
        </div>
    </header>
);

export default Header;
